import { TriggerObject, WorkflowRun } from 'dashboard/models/workflow-run';
import { WorkflowRunSimulated } from 'dashboard/models/workflow-run-simulated';
import { WorkflowRunStep, WorkflowRunStepKnownObjects } from 'dashboard/models/workflow-step';
import { WorkflowRunActions, WorkflowRunActionType } from 'dashboard/redux/actions/workflow-run';

export interface WorkflowRunState {
  workflowRun: WorkflowRun | WorkflowRunSimulated | null;
  steps: WorkflowRunStep[];
  loopChildrenSteps: Record<string, Record<number, WorkflowRunStep[]>>;
  triggerObject: TriggerObject | null;
  knownObjects: WorkflowRunStepKnownObjects[];
}

const initialState: WorkflowRunState = {
  workflowRun: null,
  steps: [],
  loopChildrenSteps: {},
  triggerObject: null,
  knownObjects: [],
};

export default (state: WorkflowRunState = initialState, action: WorkflowRunActions) => {
  switch (action.type) {
    case WorkflowRunActionType.SetWorkflowRun: {
      return {
        ...state,
        workflowRun: action.payload.workflowRun,
      };
    }

    case WorkflowRunActionType.SetWorkflowRunSteps: {
      return {
        ...state,
        steps: action.payload.steps,
      };
    }

    case WorkflowRunActionType.SetWorkflowRunLoopChildrenSteps: {
      const updatedLoopChildrenSteps = { ...state.loopChildrenSteps };

      Object.entries(action.payload.loopChildrenSteps).forEach(([token, data]) => {
        updatedLoopChildrenSteps[token] = {
          ...updatedLoopChildrenSteps[token],
          ...data,
        };
      });

      return {
        ...state,
        loopChildrenSteps: updatedLoopChildrenSteps,
      };
    }

    case WorkflowRunActionType.SetWorkflowRunTriggerObject:
      return {
        ...state,
        triggerObject: action.payload.triggerObject,
      };

    case WorkflowRunActionType.SetWorkflowRunKnownObjects: {
      return {
        ...state,
        knownObjects: action.payload.knownObjects,
      };
    }

    case WorkflowRunActionType.ClearWorkflowRun: {
      return initialState;
    }

    default:
      return state;
  }
};
